import React, { useEffect, useLayoutEffect, useMemo, useState } from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import CheckIcon from "@material-ui/icons/Check";
import axios from "axios";
import { APIURI } from "../config";
import copy from "copy-to-clipboard";
import createMarkup from "../utils/CreateMarkup";

const CreateJoinTeam = ({
  podDetails,
  isSomeThingUpdated,
  createJoinPageDesc,
  isCustomBlueTheme,
}) => {
  const [joinATeamModal, setJoinATeamModal] = useState(false);
  const [codeForJoin, setCodeForJoin] = useState("");
  const [createATeamModal, setCreateATeamModal] = useState(false);
  const [TeamName, setTeamName] = useState("");
  const [btnLoad, setBtnLoad] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isCopied, setIsCopied] = useState(false);
  const [togglePopoverArr, setTooglePopoverArr] = useState([]);
  const [togglePopover, setTooglePopover] = useState(false);
  const [togglePopoverMessage, setTooglePopoverMessage] = useState([]);
  const [errorModal, setErrorModal] = useState(false);
  const [isCreateTeamORJoinTeam, setIsCreateTeamORJoinTeam] = useState("");
  const [fontsReady, setFontsReady] = useState(false);
  const accessToken = localStorage.getItem("accesstoken");
  const themeEnabled = podDetails?.theme_enabled ?? false;
  const theme = podDetails?.theme ?? null;

  // All theme styles in one place — direct hex values, no var() dependency
  const hasFonts = Boolean(
    theme?.fonts?.title || theme?.fonts?.body || theme?.fonts?.button
  );

  // All theme styles in one place — direct hex values, no var() dependency
  const themeCSS = useMemo(() => {
    if (!themeEnabled || !theme || !podDetails?._id) return "";
    const podId = podDetails._id;
    const bg = theme.colors?.background ?? "#ffffff";
    const ui = theme.colors?.ui ?? "#000000";
    const btnBg = theme.colors?.button_background ?? "#000000";
    const btnText = theme.colors?.button_text ?? "#ffffff";
    const hasTitleFont = Boolean(theme.fonts?.title);
    const hasBodyFont = Boolean(theme.fonts?.body);
    const hasButtonFont = Boolean(theme.fonts?.button);
    return `
      ${hasTitleFont ? `@font-face { font-family: 'PodFont-title';  src: url('${APIURI}/pods/podFont/${podId}/title')  format('truetype'); font-display: block; }` : ""}
      ${hasBodyFont ? `@font-face { font-family: 'PodFont-body';   src: url('${APIURI}/pods/podFont/${podId}/body')   format('truetype'); font-display: block; }` : ""}
      ${hasButtonFont ? `@font-face { font-family: 'PodFont-button'; src: url('${APIURI}/pods/podFont/${podId}/button') format('truetype'); font-display: block; }` : ""}

      .pod-theme-page {
        background-color: ${bg} !important;
        color: ${ui} !important;
      }
      .pod-theme-ui {
        color: ${ui} !important;
      }
      .pod-theme-label-color{
        color: ${bg} !important;
      }
      ${hasTitleFont ? `
      .pod-theme-title {
        font-family: 'PodFont-title' !important;
      }` : ""}
      ${hasBodyFont ? `
      .pod-theme-body {
        font-family: 'PodFont-body' !important;
      }
      #alert-dialog-description p{
        font-family: 'PodFont-body' !important;
      }` : ""}
      ${hasButtonFont ? `
      .pod-theme-button {
        font-family: 'PodFont-button' !important;
      }` : ""}
      .pod-theme-btn.MuiButtonBase-root,
      .pod-theme-btn.MuiButtonBase-root:hover,
      .pod-theme-btn.MuiButtonBase-root:focus {
        background-color: ${btnBg} !important;
        color: ${btnText} !important;
        ${hasButtonFont ? `font-family: 'PodFont-button' !important;` : ""}
        /* Allow the button to grow vertically when the dynamic font is tall */
        height: auto !important;
        padding: 16px !important;
        /* Flex column so the label child is vertically centered */
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        justify-content: center !important;
      }
      .pod-theme-btn.MuiButtonBase-root .MuiButton-label {
        ${hasButtonFont ? `font-family: 'PodFont-button' !important;` : ""}
        color: ${btnText} !important;
        /* line-height > 1 gives ascenders/descenders room to breathe */
        line-height: normal !important;
        word-break: break-word !important;
        text-align: center !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        margin-top: 0 !important;
        width: 100% !important;
      }
      .pod-theme-hr {
        border: none !important;
        height: 2px !important;
        background-color: ${btnBg} !important;
      }
      ${hasButtonFont ? `
      .tooltip span {
        font-family: 'PodFont-button' !important;
      }` : ""}
      .image--capture--modal--close--btn::before,
      .image--capture--modal--close--btn::after {
        background-color: ${btnText} !important;
      }
    `;
  }, [themeEnabled, theme, podDetails]);

  useLayoutEffect(() => {
    if (!themeEnabled || !theme || !hasFonts) {
      setFontsReady(true);
      return;
    }
    setFontsReady(false);
    document.fonts.ready.then(() => setFontsReady(true));
  }, [themeCSS, hasFonts, themeEnabled, theme]);

  let config;
  config = {
    headers: { Authorization: `Bearer ${accessToken}` },
  };

  async function handleTooltip() {
    let elements = document.getElementsByClassName("tooltip");
    let arr = await togglePopoverArr;
    let myFunction = function (e, i, acID) {
      e.preventDefault();
      console.log(arr);
      console.log(e, i, arr[0][acID]);
      setTooglePopover(true);
      setTooglePopoverMessage(arr[0][acID]);
    };

    for (let i = 0; i < elements.length; i++) {
      let actionBtn = elements[i];
      let actionBtnId = actionBtn.id.split("-");
      // console.log(actionBtnId[1]);
      actionBtn.addEventListener(
        "mousedown",
        (e) => myFunction(e, i, actionBtnId[1]),
        false,
      );
    }
  }

  const handleRemoveFromTeam = () => {
    axios
      .get(`${APIURI}/web-teams/removeFromOtherTeams`, config)
      .then((res) => {
        console.log(res);
        setBtnLoad(false);
        setErrorModal(true);
      })
      .catch((err) => {
        console.log(err);
        setErrorMessage("Something Went Wrong!");
        setBtnLoad(false);
      });
  };

  const handleCreateTeam = () => {
    setIsCreateTeamORJoinTeam("createTeam");
    setBtnLoad(true);
    axios
      .post(
        `${APIURI}/web-teams/createTeam/${podDetails.game_id}`,
        { pod_id: podDetails._id, teamName: TeamName },
        config,
      )
      .then((res) => {
        console.log(res);
        isSomeThingUpdated();
        setBtnLoad(false);
      })
      .catch((err) => {
        console.log(err.response);
        if (
          err.response &&
          err.response.data.message ===
            "Team Name or Team Code already exists for this pod id"
        ) {
          setBtnLoad(false);
          setErrorMessage("Team name already in use. Please choose another.");
        } else if (
          err.response &&
          err.response.data.message ===
            "User is already a part of another active pod"
        ) {
          handleRemoveFromTeam();
        } else {
          setBtnLoad(false);
          setErrorMessage(err.response.data.message);
        }
      });
  };

  const handleJoinTeam = () => {
    setIsCreateTeamORJoinTeam("joinTeam");
    setBtnLoad(true);
    axios
      .post(
        `${APIURI}/web-teams/joinTeam`,
        { pod_id: podDetails._id, teamCode: codeForJoin },
        config,
      )
      .then((res) => {
        console.log(res);
        isSomeThingUpdated();
        setBtnLoad(false);
      })
      .catch((err) => {
        console.log(err.response);

        if (err.response.data.message === "Team code does not exist") {
          setErrorMessage("Invalid code. Codes are case sensitive.");
          setBtnLoad(false);
        } else if (
          err.response &&
          err.response.data.message ===
            "User is already a part of another active pod"
        ) {
          handleRemoveFromTeam();
        } else {
          setErrorMessage(err.response.data.message);
          setBtnLoad(false);
        }
      });
  };

  const handleClosePopover = () => {
    setTooglePopover(false);
    // window.location.reload();
    // handleTooltip();
  };

  const handlePopUps = (data) => {
    let desc = data;
    if (podDetails && podDetails.Pod_popup) {
      let arrPop = togglePopoverArr;
      arrPop.push(podDetails.Pod_popup.map((te) => te.description));
      console.log(arrPop);
      setTooglePopoverArr(arrPop);
    }
    if (podDetails && podDetails.Pod_popup) {
      podDetails.Pod_popup.map((te, i) => {
        if (te.icon) {
          desc = desc.replaceAll(
            te.identifier,
            `<span class="tooltip" id='tooltip-${i}'><img src="${te.icon}" alt="PopupIcon" /><span>${te.title}</span></span>`,
          );
        } else {
          desc = desc.replaceAll(
            te.identifier,
            `<span class="tooltip" id='tooltip-${i}'><img src ="/assets/PopupIcon.svg" alt="PopupIcon" /><span>${te.title}</span></span>`,
          );
        }
        handleTooltip();
      });
    }
    return (
      <div
        className={`desc-Text-solution${themeEnabled && theme ? " pod-theme-body pod-theme-ui" : ""}`}
        dangerouslySetInnerHTML={createMarkup(desc)}
      />
    );
  };

  const popupMemo = useMemo(() => handlePopUps(createJoinPageDesc), []);

  // useEffect(() => {
  //   if (podDetails && podDetails.Pod_popup) {
  //     let arrPop = togglePopoverArr;
  //     arrPop.push(podDetails.Pod_popup.map((te) => te.description));
  //     console.log(arrPop)
  //     setTooglePopoverArr(arrPop);
  //     handleTooltip();
  //   }
  // }, []);

  const handleOkayBtn = (e) => {
    e.preventDefault();
    setErrorModal(false);
    if (isCreateTeamORJoinTeam === "createTeam") {
      handleCreateTeam();
    } else {
      handleJoinTeam();
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  if (themeEnabled && theme && !fontsReady) {
    return null;
  }
  return (
    <>
      <style>{themeCSS}</style>
      <div
        className={`Solution${themeEnabled && theme ? " pod-theme-page" : ""}`}
        style={
          themeEnabled && theme
            ? { marginTop: "-34px", paddingTop: "34px", minHeight: "100vh" }
            : {}
        }
      >
        <div className="header">
          <h2
            className={`solutionTitle${themeEnabled && theme ? " pod-theme-title" : ""}`}
          >
            {podDetails && podDetails.title}
          </h2>
        </div>
        <hr
          style={
            themeEnabled && theme
              ? {
                  border: "none",
                  height: "2px",
                  backgroundColor: theme.colors?.button_background,
                }
              : {}
          }
        />
        <div className="container-sol">
          <div
            className={
              themeEnabled && theme ? "pod-theme-body pod-theme-ui" : ""
            }
          >
            {popupMemo}
          </div>
          <div className="container-code">
            <Button
              className={`submit--btn${themeEnabled && theme ? " pod-theme-btn" : ""}`}
              variant="contained"
              onClick={() => {
                setCreateATeamModal(true);
              }}
            >
              CREATE A TEAM
            </Button>
            <Button
              className={`submit--btn${themeEnabled && theme ? " pod-theme-btn" : ""}`}
              variant="contained"
              onClick={() => {
                setJoinATeamModal(true);
              }}
            >
              JOIN A TEAM
            </Button>
          </div>
        </div>
      </div>

      {/* join a team modal  */}
      <Dialog
        open={joinATeamModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="access--code--modal create--join--team--modals"
      >
        <DialogTitle id="alert-dialog-title" className="access--code--required">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span className={themeEnabled && theme ? "pod-theme-title" : ""}>
              {"JOIN A TEAM"}
            </span>
            <Button
              className={`image--capture--modal--close--btn${themeEnabled && theme ? " pod-theme-btn" : ""}`}
              autoFocus
              variant="contained"
              onClick={() => {
                setCodeForJoin("");
                setErrorMessage("");
                setJoinATeamModal(false);
              }}
            ></Button>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="Location-Footer-Content">
            <div className="loc-enter">
              <label
                className={`access--code--required--label${themeEnabled && theme ? " pod-theme-button pod-theme-label-color" : ""}`}
              >
                ENTER CODE
              </label>
              <input
                type="text"
                defaultValue={codeForJoin}
                placeholder="TYPE HERE"
                autoCorrect="off"
                autoCapitalize="none"
                onChange={(e) => {
                  setCodeForJoin(e.target.value);
                  setErrorMessage("");
                }}
                className={themeEnabled && theme ? "pod-theme-body" : ""}
                style={{ marginBottom: "10px" }}
              />
            </div>
            <p
              className={themeEnabled && theme ? "pod-theme-body" : ""}
              style={{ color: "#dc3545", margin: "0", fontWeight: "700" }}
            >
              {errorMessage ? errorMessage : ""}
            </p>
          </div>
        </DialogContent>
        <DialogActions style={{ padding: "16px 24px" }}>
          <Button
            className={`dialog-btn-dismiss${themeEnabled && theme ? " pod-theme-btn" : ""}`}
            autoFocus
            variant="contained"
            style={{
              width: "100%",
              opacity: `${codeForJoin.length < 4 || btnLoad ? "0.6" : "1"}`,
            }}
            disabled={codeForJoin.length < 4 || btnLoad}
            onClick={() => {
              handleJoinTeam();
            }}
          >
            CONTINUE
          </Button>
        </DialogActions>
      </Dialog>

      {/* create a team modal  */}
      <Dialog
        open={createATeamModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="access--code--modal create--join--team--modals"
      >
        <DialogTitle id="alert-dialog-title" className="access--code--required">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span className={themeEnabled && theme ? "pod-theme-title" : ""}>
              {"CREATE A TEAM"}
            </span>
            <Button
              className={`image--capture--modal--close--btn${themeEnabled && theme ? " pod-theme-btn" : ""}`}
              autoFocus
              variant="contained"
              onClick={() => {
                setCodeForJoin("");
                setTeamName("");
                setErrorMessage("");
                setCreateATeamModal(false);
              }}
            ></Button>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="Location-Footer-Content">
            <div
              className={`loc-enter ${isCustomBlueTheme ? "loc-enter-custom" : ""}`}
            >
              <label
                className={`access--code--required--label${themeEnabled && theme ? " pod-theme-button pod-theme-label-color" : ""}`}
              >
                TEAM NAME
              </label>
              <input
                type="text"
                defaultValue={TeamName}
                autoCorrect="off" // Turn off autocorrect
                autoCapitalize="none" // Turn off autocapitalization
                placeholder="TYPE HERE"
                onChange={(e) => {
                  setTeamName(e.target.value);
                  setErrorMessage("");
                }}
                className={themeEnabled && theme ? "pod-theme-body" : ""}
                style={{ marginBottom: "10px" }}
              />
            </div>
            <p
              className={themeEnabled && theme ? "pod-theme-body" : ""}
              style={{ color: "#dc3545", margin: "0", fontWeight: "700" }}
            >
              {errorMessage ? errorMessage : ""}
              {TeamName.length > 30
                ? "Team name must not exceed 30 characters."
                : ""}
            </p>
          </div>
        </DialogContent>
        <DialogActions style={{ padding: "16px 24px" }}>
          <Button
            className={`dialog-btn-dismiss${themeEnabled && theme ? " pod-theme-btn" : ""}`}
            autoFocus
            variant="contained"
            style={{
              width: "100%",
              opacity: `${btnLoad || TeamName.length > 30 ? "0.6" : "1"}`,
            }}
            disabled={btnLoad || TeamName.length > 30}
            onClick={() => {
              handleCreateTeam();
            }}
          >
            CONTINUE
          </Button>
        </DialogActions>
      </Dialog>

      {/* popup modal  */}
      <Dialog
        open={togglePopover}
        onClose={handleClosePopover}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="PopOver"
      >
        {/* <DialogTitle id="alert-dialog-title">Message</DialogTitle> */}
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div dangerouslySetInnerHTML={createMarkup(togglePopoverMessage)} />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClosePopover}
            className={`dialog-btn-dismiss${themeEnabled && theme ? " pod-theme-btn" : ""}`}
            autoFocus
            variant="contained"
            style={{ marginBottom: "2.2rem" }}
          >
            Okay
          </Button>
          {/* <Camera onTakePhoto = { (dataUri) => { handleTakePhoto(dataUri); } }/> */}
        </DialogActions>
      </Dialog>

      {/* error modal  */}
      <Dialog
        open={errorModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {/* <DialogTitle id="alert-dialog-title">
          {"Did you skip to scan the QR Code?"}
        </DialogTitle> */}
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description "
            className={themeEnabled && theme ? "pod-theme-body" : ""}
          >
            {/* Oops! looks like you’ve skipped the previous Game QR Code, Please
            scan the Game QR Code to continue.! */}
            This account was already part of another event. You have been
            removed from that event but can rejoin at any time via that event's
            link.
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ padding: "16px 24px" }}>
          <Button
            onClick={(e) => {
              handleOkayBtn(e);
            }}
            className={`dialog-btn-dismiss ${themeEnabled && theme ? " pod-theme-btn" : ""}`}
            autoFocus
            variant="contained"
          >
            Okay
          </Button>
          {/* <Camera onTakePhoto = { (dataUri) => { handleTakePhoto(dataUri); } }/> */}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CreateJoinTeam;
